import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, ToastController, LoadingController, AlertController, ModalController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import moment from 'moment';
import { SessionUpdatePage } from './../../pages/session-update/session-update';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TaskDetailPage } from './../../pages/task-detail/task-detail';
import { DomSanitizer } from '@angular/platform-browser';

interface myInterface2 {
  id: string;
  complete: boolean;
  creationDate: Date;
  description: string;
  dueDate: Date;
  files: any[];
  idAlumno: string;
  idCoach: string;
  idSesion: string;
  title: string;
}

@IonicPage()
@Component({
  selector: 'page-session-detail',
  templateUrl: 'session-detail.html',
})
export class SessionDetailPage {
  itemSel: any;
  UsuarioObj: any;
  CoachObj: any;
  userType: number;
  myForm: FormGroup;
  myForm2: FormGroup;
  myForm3: FormGroup;
  qualification: number;
  loading: Loading;
  canCalificate: boolean = false;
  tasksCollection: AngularFirestoreCollection<myInterface2>;
  tasks: myInterface2[];

  constructor(public sanitizer: DomSanitizer, public navCtrl: NavController, public navParams: NavParams, public af: AngularFirestore, private FireAuth: AngularFireAuth, public formBuilder: FormBuilder, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public modalCtrl: ModalController) {
    this.myForm = this.formBuilder.group({
      description: ['']
    });
    this.myForm2 = this.formBuilder.group({
      observations: ['', Validators.required]
    });
    this.myForm3 = this.formBuilder.group({
      internalComments: ['', Validators.required]
    });

    this.itemSel = navParams.get('item');
    if (this.itemSel && this.itemSel.id) {
      this.af.doc("Sessions/" + this.itemSel.id).snapshotChanges().subscribe(data => {
        if (data.payload.exists) {
          const id = data.payload.id;
          const data2 = data.payload.data();
          const date = data.payload.data().sessionDate;
          this.itemSel = { id, ...data2 }
          //Date comparasion
          this.canCalificate = new Date(date) <= new Date() ? true : false;
        }
      });
      this.tasksCollection = af.collection("Tasks", ref => ref.where("idSesion", "==", this.itemSel.id).orderBy("dueDate", "desc"));
      this.tasksCollection.snapshotChanges().subscribe((data) => {
        this.tasks = data.map((item) => {
          const data = item.payload.doc.data() as myInterface2;
          const id = item.payload.doc.id;
          return { id, ...data }
        });
      });
    }
    if (this.itemSel && this.itemSel.idAlumno) {
      this.af.doc("Users/" + this.itemSel.idAlumno).snapshotChanges().subscribe(document => {
        if (document.payload.exists) {
          this.UsuarioObj = document.payload.data();
        }
      });
    }
    if (this.itemSel && this.itemSel.idCoach) {
      this.af.doc("Users/" + this.itemSel.idCoach).snapshotChanges().subscribe(document => {
        if (document.payload.exists) {
          this.CoachObj = document.payload.data();
        }
      });
    }
    this.FireAuth.auth.onAuthStateChanged(data => {
      if (data && data.uid) {
        this.af.doc("Users/" + data.uid).snapshotChanges().subscribe(document => {
          if (document.payload.exists) {
            this.userType = document.payload.data() && document.payload.data().type ? document.payload.data().type : 0;
          }
        });
      }
    });
    // ////console.log("Session detail");
    // ////console.log(this.itemSel);
  }

  ionViewDidLoad() { }

  stringDate(date: any): string {
    moment.locale("es");
    return moment(date).format("lll");
  }

  starClicked(value) {
    this.qualification = value;
  }

  DateD(date): string {
    return moment(date).format('YYYYMMDDTHHmmss');
  }

  DateDP(date): string {
    let newDate = moment(date).add(1, "hours");
    return moment(newDate).format('YYYYMMDDTHHmmss');
  }

  cancel() {
    this.navCtrl.pop();
  }

  onSubmit() {
    this.presentLoadingCustom();
    let data = { "description": this.myForm.value.description, "score": this.qualification }
    this.af.doc("Sessions/" + this.itemSel.id).update({ "qualification": data }).then(() => {
      this.itemSel.qualification = { "description": this.myForm.value.description, "score": this.qualification };
      this.loading.dismiss();
      this.presentToast("Calificación guardada!");
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
      ////console.error(error);
    });
  }
  onSubmit2() {
    this.presentLoadingCustom();
    this.af.doc("Sessions/" + this.itemSel.id).update({ "observations": this.myForm2.value.observations }).then(() => {
      this.itemSel.observations = this.myForm2.value.observations;
      this.loading.dismiss();
      this.presentToast("Observaciones guardadas!");
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
      ////console.error(error);
    });
  }

  onSubmit3() {
    this.presentLoadingCustom();
    this.af.doc("Sessions/" + this.itemSel.id).update({ "internalComments": this.myForm3.value.internalComments }).then(() => {
      this.itemSel.internalComments = this.myForm3.value.internalComments;
      this.loading.dismiss();
      this.presentToast("Comentarios internos guardados!");
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
      ////console.error(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  presentConfirmDelete(id: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar sesión',
      message: '¿Estas seguro de eliminar sesión?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id);
          }
        }
      ]
    });
    alert.present();
  }

  deleteItem(id: string) {
    this.presentLoadingCustom();
    this.af.collection("Sessions").doc(id).delete().then(() => {
      this.af.collection("Tasks").ref.where("idSesion", "==", id).get().then(collection => {
        const batch = this.af.firestore.batch();
        collection.forEach(document => {
          document.ref
          batch.delete(document.ref);
        });
        batch.commit().then(() => {
          this.loading.dismiss();
          this.presentToast('Eliminado correctamente');
          this.navCtrl.pop();
        }).catch(error => {
          this.loading.dismiss();
          this.presentToast('Ha ocurrido un error');
          this.navCtrl.pop();
        });
      }).catch(error => {
        this.loading.dismiss();
        this.presentToast('Ha ocurrido un error');
        this.navCtrl.pop();
      });

    }).catch(error => {
      this.loading.dismiss();
      this.presentToast('Ha ocurrido un error');
      this.navCtrl.pop();
    });
  }

  updateItem(item: any) {
    let Modal = this.modalCtrl.create(SessionUpdatePage, { "item": item });
    Modal.present();
  }

  goToTask(item: any) {
    let Modal = this.modalCtrl.create(TaskDetailPage, { "item": item });
    Modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/session-detail/session-detail.ts